import React from 'react';
import { Link } from 'react-router-dom';
import { EDITORIAL_ROUTES } from '../content/index.js';
import { openCookieSettings } from './CookieConsent.jsx';

/**
 * Site footer.
 *
 * Two jobs beyond navigation: it is the only route to reopening cookie
 * preferences once the banner has been dismissed, and it is where a reviewer
 * looks for the About / Contact / Privacy links.
 */
export default function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer" role="contentinfo">
      <nav className="app-footer__nav" aria-label="Footer">
        {EDITORIAL_ROUTES.filter(r => r.standalone).map(route => (
          <Link key={route.path} to={route.path} className="app-footer__link">
            {route.title}
          </Link>
        ))}
        <button
          type="button"
          className="app-footer__cookie-link"
          onClick={openCookieSettings}
        >
          Cookie preferences
        </button>
      </nav>
      <p className="app-footer__legal">
        &copy; {year} TalkMuch. All rights reserved.
      </p>
    </footer>
  );
}
